export default __webpack_public_path__ + "img/1_12-b125f197.png";